import React from 'react';
import './AppOffline.css';
import { IonButton, IonIcon } from '@ionic/react';
import { useTranslation } from 'react-i18next';

export default function AppOffline() {
  const [t] = useTranslation('global');

  const reload = () => {
    window.location.reload();
  };
  return (
    <>
      <div className="app-offline pt-5 ion-text-center">
        <IonIcon src="assets/icon/offline.svg"></IonIcon>
        <p className="pt-2">{t('home.offline')}</p>
      </div>
      <div className="pt-5 ion-text-center">
        <IonButton className="btn-default btn-wide-80" onClick={() => reload()}>
          {t('home.retry')}
        </IonButton>
      </div>
    </>
  );
}
